export default "__VITE_ASSET__fAJaC7nO__"